import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { 
  FaEnvelope, 
  FaPhone, 
  FaMapMarkerAlt,
  FaPaperPlane
} from 'react-icons/fa';
import { HiSparkles, HiLightningBolt } from 'react-icons/hi';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      // EmailJS configuration
      const serviceId = 'contact_1';
      const templateId = 'template_contact'; // You'll need to create this template in EmailJS dashboard
      const publicKey = 'p2iI2CPilFEhpnchc';
      
      // Send email using EmailJS
      await emailjs.send(
        serviceId,
        templateId,
        {
          from_name: formData.name,
          from_email: formData.email,
          company: formData.company,
          subject: formData.subject,
          message: formData.message,
          to_email: 'cascadeindia@company.com' // Replace with actual company email
        },
        publicKey
      );
      
      setSuccess(true);
      setFormData({
        name: '',
        email: '',
        company: '',
        subject: '',
        message: ''
      });
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <Navbar />

      {/* Hero Section */}
      <section className="contact-hero">
        <div className="hero-bg">
          <div className="hero-gradient-orb orb-1"></div>
          <div className="hero-gradient-orb orb-2"></div>
          <div className="hero-grid"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="section-badge">
              <HiSparkles />
              Get In Touch
            </div>
            <h1 className="hero-title">
              Let's Build Something <span className="gradient-text">Amazing</span>
            </h1>
            <p className="hero-description">
              Have a project in mind? We'd love to hear about it. 
              Let's discuss how we can help bring your vision to life.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section contact-section">
        <div className="container">
          <div className="contact-wrapper">
            {/* Contact Info */}
            <div className="contact-info">
              <div className="info-header">
                <div className="section-badge">
                  <HiLightningBolt />
                  Contact Info
                </div>
                <h2 className="info-title">
                  We'd Love to <span className="gradient-text">Hear From You</span>
                </h2>
                <p className="info-description">
                  Reach out through any of these channels and our team will 
                  get back to you within 24 hours.
                </p>
              </div>

              <div className="info-items">
                <div className="info-item">
                  <div className="info-icon">
                    <FaEnvelope />
                  </div>
                  <div className="info-content">
                    <h4>Email Us</h4>
                    <p>contact@cascadeindia.com</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <FaPhone />
                  </div>
                  <div className="info-content">
                    <h4>Call Us</h4>
                    <p>+91 (22) 1234 5678</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <div className="info-content">
                    <h4>Visit Us</h4>
                    <p>Mumbai, Maharashtra, India</p>
                  </div>
                </div>
              </div>


            </div>

            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <div className="form-card">
                <div className="form-card-inner">
                  {success ? (
                    <div className="success-message">
                      <div className="success-icon">
                        <FaPaperPlane />
                      </div>
                      <h3>Message Sent!</h3>
                      <p>Thank you for reaching out. We'll get back to you soon.</p>
                      <button 
                        className="btn btn-secondary"
                        onClick={() => setSuccess(false)}
                      >
                        Send Another Message
                      </button>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit} className="contact-form">
                      <div className="form-row">
                        <div className="form-group">
                          <label htmlFor="name">Your Name</label>
                          <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="John Doe"
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="email">Email Address</label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder="john@example.com"
                          />
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group">
                          <label htmlFor="company">Company (Optional)</label>
                          <input
                            type="text"
                            id="company"
                            name="company"
                            value={formData.company}
                            onChange={handleChange}
                            placeholder="Your Company"
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="subject">Subject</label>
                          <input
                            type="text"
                            id="subject"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            required
                            placeholder="How can we help?"
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="message">Your Message</label>
                        <textarea
                          id="message"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          required
                          rows="5"
                          placeholder="Tell us about your project..."
                        ></textarea>
                      </div>

                      {error && <div className="error-message">{error}</div>}

                      <button 
                        type="submit" 
                        className="btn btn-primary btn-glow btn-full"
                        disabled={loading}
                      >
                        {loading ? 'Sending...' : 'Send Message'}
                        <FaPaperPlane />
                      </button>
                    </form>
                  )}
                </div>
                <div className="card-border-glow"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
